import './App.css';
import Grid from '@mui/material/Unstable_Grid2';
import PathButtons from "./components/pathButtons.js";
import SideButtons from "./components/sideButtons.js";
import MapWindow from "./components/mapWindowCore.js";
import sailorImg from "./components/sailor_rowing.jpg"
import ArchedBannerImage from './components/overlay.js';
import { useState } from 'react';

function App() {
  const [selectedMap, changeMap ] = useState("osm/navigation");
  const [selectedRoute, changeRoute] = useState('none');

  const sideUpdate = (map)=>{
    changeMap(map);
  }

  const routeUpdate = (route)=>{
    changeRoute(route);
  }
  return (
    <div className="App">
      <Grid container>
        {/* <Grid xs={1}><SideButtons updateFunc={sideUpdate}/></Grid> */}
        <Grid xs={11}>
          {/* <MapWindow map={selectedMap} route={selectedRoute}/> */}
          <ArchedBannerImage
            imageSrc={sailorImg}
            bannerText="Follow me to RGYC.ORG"
            bannerColor="rgba(255, 140, 0, 0.6)"
            textColor="#e6eeff"
          />
        </Grid>
      </Grid>
      <PathButtons updateFunc={routeUpdate}/>
    </div>
  );
}

export default App;
